/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Phone/Existing/Content"
  
}) {
let phonesValueData = fromData.useDataValue({ viewPath,
context: 'phones',
})
let newRelationSelectedPhoneValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'selected_phone',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="phones"
 from={phonesValueData}
 onChange={onChange}
 data="new_relation.selected_phone"
 value={newRelationSelectedPhoneValueData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Choose an existing phone"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}